/*
 * ATTENTION: The "eval" devtool has been used (maybe by default in mode: "development").
 * This devtool is neither made for production nor for readable output files.
 * It uses "eval()" calls to create a separate source file in the browser devtools.
 * If you are trying to read the output file, select a different devtool (https://webpack.js.org/configuration/devtool/)
 * or disable the default devtool with "devtool: false".
 * If you are looking for production-ready output files, see mode: "production" (https://webpack.js.org/configuration/mode/).
 */
/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./zrc/scripts/templates/blog.js":
/*!***************************************!*\
  !*** ./zrc/scripts/templates/blog.js ***!
  \***************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @shopify/theme-sections */ \"./node_modules/@shopify/theme-sections/theme-sections.js\");\n/* provided dependency */ var $ = __webpack_require__(/*! jquery */ \"./node_modules/jquery/dist/jquery.js\");\n\n(0,_shopify_theme_sections__WEBPACK_IMPORTED_MODULE_0__.register)('blog-section', {\n  onLoad() {\n    this.$searchInput = this.container.querySelector('.blog-cover-search-input');\n    this.$searchButton = this.container.querySelector('.blog-cover-search-button');\n    this.setTaggsOverflowBehaviour();\n    this.initSearchInput();\n  },\n  initSearchInput() {\n    var searchActiveSuggestions = () => {\n      var timer = window.setInterval(() => {\n        var $activeSuggestions = $('.snize-ac-results').filter(':visible');\n        var $labels = $activeSuggestions.find('.snize-label').filter(':visible');\n        var $mobileInput = $activeSuggestions.find('input.snize-mobile-input-style');\n        if ($labels.length) {\n          window.clearInterval(timer);\n\n          // Detectar cuáles son las sugerencias de la barra de busqueda del Blog\n          if (!$('.blogposts-suggestions').length) {\n            $activeSuggestions.addClass('blogposts-suggestions');\n          }\n        }\n\n        // En mobile, agregar event listeners al input y una clase a las sugerencias del blog\n        // Esto solo se ejecutará una vez\n        if ($mobileInput.length && !$activeSuggestions.hasClass('blogposts-suggestions')) {\n          if (!$('.blogposts-suggestions').length) {\n            $activeSuggestions.addClass('blogposts-suggestions');\n          }\n          $mobileInput.get(0).addEventListener('input', searchActiveSuggestions);\n          $mobileInput.get(0).addEventListener('keydown', searchActiveSuggestions);\n          $mobileInput.get(0).addEventListener('focus', searchActiveSuggestions);\n        }\n      }, 150);\n    };\n    var handleInputListener = () => {\n      if (this.$searchInput.value === '') {\n        return;\n      }\n      searchActiveSuggestions();\n    };\n    var handleFocusListener = () => {\n      if (this.$searchInput.value === '') {\n        return;\n      }\n      searchActiveSuggestions();\n    };\n    var handleClickListener = () => {\n      if (window.isMobile()) {\n        searchActiveSuggestions();\n      }\n    };\n    var handleClickButtonListener = event => {\n      event.preventDefault();\n      this.$searchInput.focus();\n    };\n    this.$searchInput.addEventListener('input', handleInputListener);\n    this.$searchInput.addEventListener('keydown', handleInputListener);\n    this.$searchInput.addEventListener('focus', handleFocusListener);\n    this.$searchInput.addEventListener('click', handleClickListener);\n    this.$searchInput.addEventListener('mousedown', handleClickListener);\n    this.$searchInput.addEventListener('touchend', handleClickListener);\n    this.$searchInput.addEventListener('touchstart', handleClickListener);\n    this.$searchButton.addEventListener('click', handleClickButtonListener);\n  },\n  setTaggsOverflowBehaviour() {\n    // Function para poder hacer el cambio de golpe del diseño \"rebasado\" de las tags al hacer resize\n\n    // seleccionamos el wrapper general de los botones.\n    var $tagsRow = this.container.querySelector('.blog-tags');\n    // seleccionamos el div con overflow\n    var $containerToCheck = $tagsRow.querySelector('.blog-tags-inner');\n    function addClassToWrapper() {\n      // Funcion para que añada una clase al wrapper una vez que este tenga una barra horizontal\n\n      // Quitamos la clase primero, para que se calcule todo en su \"Estado normal\"\n      $tagsRow.classList.remove('js-has-scroll');\n\n      // hacemos el chequeo de si tiene barra horizontal\n      var hasHorizontalScrollbar = $containerToCheck.scrollWidth > $containerToCheck.clientWidth;\n\n      // Si es que no se tiene barra horizontal, ya no hacemos nada.\n      if (hasHorizontalScrollbar === false) {\n        return;\n      }\n\n      // añadimos la clase en caso de tener barra horizontal\n      $tagsRow.classList.add('js-has-scroll');\n    }\n    function checkIfScrollReachedEnd() {\n      if ($tagsRow.classList.contains('js-has-scroll') === false) {\n        return;\n      }\n      var maxScroll = $containerToCheck.scrollWidth - $containerToCheck.clientWidth;\n      var currentScrollPosition = Math.ceil($containerToCheck.scrollLeft);\n      if (currentScrollPosition !== maxScroll) {\n        $tagsRow.classList.remove('js-scroll-end');\n        return;\n      }\n      $tagsRow.classList.add('js-scroll-end');\n    }\n    function checkToShowLeftArrow() {\n      if ($tagsRow.classList.contains('js-has-scroll') === false) {\n        return;\n      }\n\n      // let currentPaddingLeft = parseInt(window.getComputedStyle($containerToCheck).paddingLeft, 10);\n      // currentPaddingLeft /= 2;\n      if ($containerToCheck.scrollLeft > 0) {\n        $tagsRow.classList.add('js-scroll--show-left-arrow');\n        return;\n      }\n      $tagsRow.classList.remove('js-scroll--show-left-arrow');\n    }\n\n    // declaramos el observador, y lo que hara\n    var resizeObserver = new window.ResizeObserver(() => {\n      addClassToWrapper();\n    });\n\n    // inicializamos el observador para que \"vea\" el resize de solo el elemento que queremos.\n    resizeObserver.observe($tagsRow);\n    addClassToWrapper();\n    $containerToCheck.addEventListener('scroll', () => {\n      checkToShowLeftArrow();\n      checkIfScrollReachedEnd();\n    });\n  }\n});\n\n//# sourceURL=webpack://getmore-workflow/./zrc/scripts/templates/blog.js?");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		if(__webpack_module_cache__[moduleId]) {
/******/ 			return __webpack_module_cache__[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/******/ 	// the startup function
/******/ 	// It's empty as some runtime module handles the default behavior
/******/ 	__webpack_require__.x = x => {};
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// Promise = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"main-blog": 0
/******/ 		};
/******/ 		
/******/ 		var deferredModules = [
/******/ 			["./zrc/scripts/templates/blog.js","commons"]
/******/ 		];
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		var checkDeferredModules = x => {};
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime, executeModules] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0, resolves = [];
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					resolves.push(installedChunks[chunkId][0]);
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			for(moduleId in moreModules) {
/******/ 				if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 					__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 				}
/******/ 			}
/******/ 			if(runtime) runtime(__webpack_require__);
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			while(resolves.length) {
/******/ 				resolves.shift()();
/******/ 			}
/******/ 		
/******/ 			// add entry modules from loaded chunk to deferred list
/******/ 			if(executeModules) deferredModules.push.apply(deferredModules, executeModules);
/******/ 		
/******/ 			// run deferred modules when all chunks ready
/******/ 			return checkDeferredModules();
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkgetmore_workflow"] = self["webpackChunkgetmore_workflow"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 		
/******/ 		function checkDeferredModulesImpl() {
/******/ 			var result;
/******/ 			for(var i = 0; i < deferredModules.length; i++) {
/******/ 				var deferredModule = deferredModules[i];
/******/ 				var fulfilled = true;
/******/ 				for(var j = 1; j < deferredModule.length; j++) {
/******/ 					var depId = deferredModule[j];
/******/ 					if(installedChunks[depId] !== 0) fulfilled = false;
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferredModules.splice(i--, 1);
/******/ 					result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
/******/ 				}
/******/ 			}
/******/ 			if(deferredModules.length === 0) {
/******/ 				__webpack_require__.x();
/******/ 				__webpack_require__.x = x => {};
/******/ 			}
/******/ 			return result;
/******/ 		}
/******/ 		var startup = __webpack_require__.x;
/******/ 		__webpack_require__.x = () => {
/******/ 			// reset startup function so it can be called again when more startup code is added
/******/ 			__webpack_require__.x = startup || (x => {});
/******/ 			return (checkDeferredModules = checkDeferredModulesImpl)();
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	// run startup
/******/ 	__webpack_require__.x();
/******/ })()
;